module.exports = __webpack_public_path__ + "img/驴妈妈旅游.cdcda8f7.png";